import axios from "axios";
import {
  CLEAR_ERROR,
  CREATE_COA_FAIL, CREATE_COA_REQUEST, CREATE_COA_RESET, CREATE_COA_SUCCESS, GET_ALL_PRODUCTS_FAIL, GET_ALL_PRODUCTS_REQUEST, GET_ALL_PRODUCTS_SUCCESS, GET_COA_FAIL, GET_COA_REQUEST, GET_COA_SUCCESS, GET_COAs_FAIL, GET_COAs_REQUEST, GET_COAs_SUCCESS, GET_CREATED_BY_FAIL, GET_CREATED_BY_REQUEST, GET_CREATED_BY_SUCCESS, GET_SELECT_PRODUCT_FAIL, GET_SELECT_PRODUCT_REQUEST, GET_SELECT_PRODUCT_SUCCESS, UPDATE_COA_FAIL, UPDATE_COA_REQUEST, UPDATE_COA_SUCCESS
  
} from '../constants/productConstant'



// const host = "http://62.72.31.157:4001"
import { host } from "../../utils/config.js";
// const host = "http://localhost:40 01";

// const host = "https://sanwariya-portal.onrender.com";



export const createCoa = (details) => async (dispatch) => {
  try {
    dispatch({ type: CREATE_COA_REQUEST });
    const config = { headers: { "Content-Type": "application/json" }, withCredentials: true };


    const data = await axios.post(`${host}/api/v1/coa/create`, details, config);

    dispatch({ type: CREATE_COA_SUCCESS, payload: data.data });
  } catch (error) {

    dispatch({
      type: CREATE_COA_FAIL,
      payload: error.response?.data.message,
    });
  }
};

export const updateCoa = (coaId, details) => async (dispatch) => {
  try {
    dispatch({ type: UPDATE_COA_REQUEST });
    const config = { headers: { "Content-Type": "application/json" }, withCredentials: true };

    const data = await axios.put(`${host}/api/v1/coa/update/${coaId}`, details, config);

    dispatch({ type: UPDATE_COA_SUCCESS, payload: data.data });
    // console.log(data.user)
  } catch (error) {
    dispatch({
      type: UPDATE_COA_FAIL,
      payload: error.response?.data.message,
    });
  }
};

export const getCoas = (keyword = '', CurrentPage = 1,print='',selProduct='') => async (dispatch) => {
  try {
    dispatch({ type: GET_COAs_REQUEST });
    const config = { headers: { "Content-Type": "application/json" }, withCredentials: true };
    let link = `${host}/api/v1//all-coa?keyword=${keyword}&page=${CurrentPage}&print=${print}&selProduct=${selProduct}`;

    const data = await axios.get(link, config);

    dispatch({ type: GET_COAs_SUCCESS, payload: data.data });
    // console.log(data.user)
  } catch (error) {
    dispatch({
      type: GET_COAs_FAIL,
      payload: error.response?.data.message,
    });
  }
};

export const getCoa = (coaId) => async (dispatch) => {
  try {
    dispatch({ type: GET_COA_REQUEST });
    const config = { headers: { "Content-Type": "application/json" }, withCredentials: true };

    const data = await axios.get(`${host}/api/v1/coa/${coaId}`, config);

    dispatch({ type: GET_COA_SUCCESS, payload: data.data });
    // console.log(data.user)
  } catch (error) {
    dispatch({
      type: GET_COA_FAIL,
      payload: error.response?.data.message,
    });
  }
};

export const getProduct = (productId,type) => async (dispatch) => {
  try {
    dispatch({ type: GET_SELECT_PRODUCT_REQUEST });
    const config = { headers: { "Content-Type": "application/json" }, withCredentials: true }

    const data = await axios.get(`${host}/api/v1/get/product/${productId}?type=${type}`, config);

    dispatch({ type: GET_SELECT_PRODUCT_SUCCESS, payload: data.data });

  } catch (error) {
    dispatch({
      type: GET_SELECT_PRODUCT_FAIL,
      payload: error.response?.data.message,
    });
  }
};
export const getProducts = () => async (dispatch) => {
  try {
    dispatch({ type: GET_ALL_PRODUCTS_REQUEST });
    const config = { headers: { "Content-Type": "application/json" }, withCredentials: true };

    console.log(`${host}/api/v1/products`)
    const data = await axios.get(`${host}/api/v1/products`, config);

    dispatch({ type: GET_ALL_PRODUCTS_SUCCESS, payload: data.data });
    // console.log(data.user)
  } catch (error) {
    dispatch({
      type: GET_ALL_PRODUCTS_FAIL,
      payload: error.response?.data.message,
    });
  }
};
export const getCreatedBy = () => async (dispatch) => {
  try {
    dispatch({ type: GET_CREATED_BY_REQUEST });
    const config = { headers: { "Content-Type": "application/json" }, withCredentials: true };

    console.log(`${host}/api/v1/products`)
    const data = await axios.get(`${host}/api/v1/created-by`, config);

    dispatch({ type: GET_CREATED_BY_SUCCESS, payload: data.data });
    // console.log(data.user)
  } catch (error) {
    dispatch({
      type: GET_CREATED_BY_FAIL,
      payload: error.response?.data.message,
    });
  }
};

export const clearError = () => async (dispatch) => {
  dispatch({ type: CLEAR_ERROR });
};
